/* eslint-disable react/button-has-type */
import React, { useRef, useEffect } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from 'theme/withStyles';

const VARIANTS = ['primary', 'secondary', 'tertiary'];

const styles = ({ oaoButtons: buttons }) => ({
  primary: {
    '& .spinner': {
      '& svg': {
        '& circle': {
          stroke: buttons.primary.color,
        },
      },
      position: 'absolute',
      right: 10,
      top: 12,
    },
    '&:hover': {
      background: buttons.primary.hoverBackground,
      borderColor: buttons.primary.hoverBorderColor,
      color: buttons.primary.hoverColor,
    },
    background: buttons.primary.background,
    border: buttons.primary.border,
    borderColor: buttons.primary.borderColor,
    borderRadius: buttons.primary.borderRadius,
    color: buttons.primary.color,
    fontFamily: buttons.primary.fontFamily,
    fontSize: buttons.primary.fontSize,
    fontWeight: buttons.primary.fontWeight,
    padding: buttons.primary.padding,
    position: 'relative',
    textAlign: 'center',
    transition: 'background 200ms ease',
  },
  root: {
    '&:disabled': {
      cursor: 'not-allowed',
      opacity: 0.6,
    },
    cursor: 'pointer',
  },
  secondary: {
    '&:hover': {
      background: buttons.secondary.hoverBackground,
      borderColor: buttons.secondary.hoverBorderColor,
      color: buttons.secondary.hoverColor,
    },
    background: buttons.secondary.background,
    border: buttons.secondary.border,
    color: buttons.secondary.color,
    fontFamily: buttons.secondary.fontFamily,
    fontSize: buttons.secondary.fontSize,
    fontWeight: buttons.secondary.fontWeight,
    padding: buttons.secondary.padding,
    position: 'relative',
    textAlign: 'center',
    top: -3,
  },
  tertiary: {
    ...buttons.tertiary,
    '&:hover': {
      background: buttons.tertiary.hoverBackground,
      borderColor: buttons.tertiary.hoverBorderColor,
      color: buttons.tertiary.hoverColor,
    },
    display: 'block',
  },
});

const Button = ({
  autofocus,
  children,
  className,
  classes,
  theme: _theme,
  type,
  variant,
  ...props
}) => {
  const buttonRef = useRef(null);
  useEffect(() => {
    if (autofocus) {
      setTimeout(() => {
        buttonRef.current.focus();
      });
    }
  }, [autofocus]);
  return (
    <button
      ref={buttonRef}
      type={type}
      className={classnames(className, classes.root, classes[variant])}
      {...props}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  autofocus: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  theme: PropTypes.shape({}).isRequired,
  type: PropTypes.string,
  variant: PropTypes.oneOf(VARIANTS),
};

Button.defaultProps = {
  autofocus: false,
  children: null,
  className: '',
  type: 'button',
  variant: 'primary',
};

export default withStyles(styles)(Button);
